import { SyntheticEvent } from 'react';

/** Simple prevent default callback on event. */
export const preventDefault = (event: Event | SyntheticEvent) => event.preventDefault();
